export default __webpack_public_path__ + "static/media/youtube.0709f88d.svg";